import React, { useState } from 'react';
import { NvTab, NvResponsiveTabsDisplayType } from 'shared/components/nv-responsive-tabs';
import { NvResponsiveTabsRow } from 'shared/components/nv-responsive-tabs-row';
import { createGridStyles } from 'styles/global_defaults/scaffolding';
import t from 'react-translate';
import { textSmallFontSize } from 'styles/global_defaults/fonts';
import { css } from '@emotion/core';
import { RailsRoutes } from 'shared/services/rails-routes';
import { AngularServicesContext } from 'react-app';
import { white } from 'styles/global_defaults/colors';
import { AnalyticsDashBoardType } from 'redux/schemas/app/analytics';
import AnalyticsDashboard from './analytics-dashboard';

const CourseAnalytics = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const { $state } = React.useContext(AngularServicesContext);
  const { catalogId } = $state?.params;
  const tabs: NvTab[] = [
    {
      text: t.COURSE_ANALYTICS.OVERVIEW(),
      onClick: () => setActiveTab('overview'),
    }, {
      text: t.COURSE_ANALYTICS.ACTIVITIES(),
      onClick: () => setActiveTab('activities'),
    },
  ];
  const tabStyles = {
    ...createGridStyles(1, 2),
    fontSize: `${textSmallFontSize}px`,
  };
  const styles = css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-right: calc(((100vw - 1024px)/2) - 10px);
    background-color: ${white};
  `;
  return (
    <>
      <div css={styles} className='analytics-header'>
        <NvResponsiveTabsRow
          style={tabStyles}
          defaultTabs={tabs}
          tabType={NvResponsiveTabsDisplayType.TEXT_ONLY}
          tabTextClass='card-title'
        />
        <div className='button-container'>
          <a
            className='bs4-btn bs4-btn-secondary w-100'
            href={RailsRoutes.analyticsPath(catalogId)}
            data-qa='analytics-link-1'
          >
            {t.COURSE_ANALYTICS.SURVEY_AND_QUIZ()}
          </a>
        </div>
      </div>
      {/* This to conditionals are neccesary to rerender the qrvey instance on click of the tabs */}
      {activeTab === 'overview'
      && <AnalyticsDashboard dashboardType={AnalyticsDashBoardType.COURSE} configKeyName={`config_${activeTab}`} pageIdKey={activeTab} />}
      {activeTab === 'activities'
      && <AnalyticsDashboard dashboardType={AnalyticsDashBoardType.COURSE} configKeyName={`config_${activeTab}`} pageIdKey={activeTab} />}
    </>
  );
};
export default CourseAnalytics;
